import { AFFILIATE, COUNTRY } from 'scenes/Campaigns/components/Form/constants';
import { CAMPAIGN_ALTERNATIVE_ID } from 'scenes/Campaigns/components/Form/Campaign/constants';

export function createGranularityFields() {
  return [];
}

export function editGranularityFields(granularity) {
  let fields = [];
  const granularityParts = granularity.split(', ');

  granularityParts.forEach((part) => {
    switch (part) {
      case 'Targeting':
        fields = [...fields, AFFILIATE, COUNTRY];
        break;
      case 'CampaignMatchingAttributes':
        fields = [...fields, CAMPAIGN_ALTERNATIVE_ID];
        break;
    }
  });
  return fields;
}
